<template>
  <div class="tx-news module-news-list -max-width-limited">
    <div class="news-list__container" ref="list">
      <template v-if="loading">
        <div v-for="item in itemsPerPage" :key="`loading-${item}`" class="news-list__card news-list__card-loading col">
          <div class="card__content">
            <div class="content__date"></div>
            <div class="content__title">
              <div class="line line-one"></div>
              <div class="line line-two"></div>
              <div class="line line-three"></div>
            </div>
            <div class="content__text">
              <div class="line line-one"></div>
              <div class="line line-two"></div>
              <div class="line line-three"></div>
            </div>
            <div class="content__link"></div>
          </div>
        </div>
      </template>
      <template v-else>
        <a v-for="singleNews in news" :key="singleNews.id" :href="singleNews.absoluteUrl" class="news-list__card">
          <div class="card__content">
            <div class="content__date">
              <span>{{ formatDate(singleNews.date) }}</span>
            </div>
            <div class="content__title">
              <span class="heading delta">{{ singleNews.title }}</span>
            </div>
            <div class="content__text">{{ singleNews.text }}</div>
            <div class="content__link icon-arrow-right-after">
              <span>{{ $t('newsCard.linkText') }}</span>
            </div>
          </div>
        </a>
      </template>
    </div>
    <div v-if="numberOfTotalItems > itemsPerPage" class="news-list__pagination">
      <div class="pagination__buttons">
        <div v-show="currentPage !== 1" @click="prevPage" class="buttons__button prev icon-arrow-left-before"></div>
        <div v-if="numberOfPages <= 5" class="less__page">
          <div v-for="page in numberOfPages" :key="page.id" @click="specificPage(page)" class="buttons__button index" :class="{ 'active' : page === currentPage }">
            {{ page }}
          </div>
        </div>
        <div v-else class="more__page">
          <div v-for="page in pageRange()" :key="page.id" @click="specificPage(page)" class="buttons__button index" :class="{ 'active' : page === currentPage }">
            {{ page }}
          </div>
        </div>
        <div v-show="currentPage !== numberOfPages" @click="nextPage" class="buttons__button next icon-arrow-right-before"></div>
      </div>
      <div class="pagination__info">
        <p>{{ $t('paginationInfo.pieceOne') }} {{ firstItemPerPage }} {{ $t('paginationInfo.pieceTwo') }} {{ lastItemPerPage }} {{ $t('paginationInfo.pieceThree') }} {{ numberOfTotalItems }} {{ $t('paginationInfo.pieceFour') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

export default {
  name: 'App',
  components: {},
  data () {
    return {
      news: [],
      newsApiError: '',
      currentPage: 1,
      numberOfPages: '',
      firstItemPerPage: 1,
      lastItemPerPage: null,
      itemsPerPage: 12,
      numberOfTotalItems: '',
      apiBase: window.app.news_list.api_base,
      selectedCategoryUid: window.app.news_list.selected_category_uid,
      queryCategory: '',
      loading: false
    }
  },
  methods: {
    getNews(currentPage)
    {
      this.loading = true
      if (this.selectedCategoryUid > 0)
      {
        this.queryCategory = `&category[equals]=${this.selectedCategoryUid}`
      }
      Axios.get(this.apiBase + 'news-news/' + '?currentPage=' + currentPage + '&itemsPerPage=' + this.itemsPerPage + this.queryCategory)
        .then((response) =>
        {
          this.news = response.data.news
          this.numberOfPages = response.data.numberOfPages
          this.numberOfTotalItems = response.data.numberOfTotalItems
          this.loading = false
        })
        .catch((error) =>
        {
          this.newsApiError += error.message
        })
    },
    formatDate (date)
    {
      let timestamp = { second: date }
      let currentDate = new Date(timestamp.second * 1000)
      let curr_day = currentDate.getDate()
      let curr_month = currentDate.getMonth() + 1 // Add +1 for take the right month because the order is from 0 to 11
      let curr_year = currentDate.getFullYear() % 100
      return ('0' + curr_day).slice(-2) + '.' + ('0' + curr_month).slice(-2) + '.' + curr_year
    },
    changeNumOfItem()
    {
      this.firstItemPerPage = (this.currentPage * this.itemsPerPage) - this.itemsPerPage + 1
      this.lastItemPerPage = this.currentPage * this.itemsPerPage
      if (this.lastItemPerPage > this.numberOfTotalItems)
      {
        this.lastItemPerPage = this.numberOfTotalItems
      }
      gsap.to(window, { duration: 0.5, scrollTo: this.$refs.list })
    },
    prevPage()
    {
      if (this.currentPage !== 1)
      {
        this.currentPage--
        this.pushState()
        this.getNews(this.currentPage)
        this.changeNumOfItem()
      }
    },
    nextPage()
    {
      if (this.currentPage !== this.numberOfPages)
      {
        this.currentPage++
        this.pushState()
        this.getNews(this.currentPage)
        this.changeNumOfItem()
      }
    },
    specificPage(index)
    {
      this.currentPage = index
      this.pushState()
      this.getNews(this.currentPage)
      this.changeNumOfItem()
    },
    pageRange()
    {
      let start = this.currentPage - 2
      let end = this.currentPage + 2

      if (end > this.numberOfPages)
      {
        start -= (end - this.numberOfPages)
        end = this.numberOfPages
      }
      if (start <= 0)
      {
        end += ((start - 1) * (-1))
        start = 1
      }
      end = end > this.numberOfPages ? this.numberOfPages : end

      let middle = start + 2
      let middleMinusOne = start + 1
      let middleOne = end - 1

      return {
        start: start,
        middleMinusOne: middleMinusOne,
        middle: middle,
        middleOne: middleOne,
        end: end
      }
    },
    pushState()
    {
      const url =  new URL(window.location.href)

      // Delete all existing params
      for (const key of url.searchParams.keys()) {
        url.searchParams.delete(key)
      }

      // Add all params
      url.searchParams.set('page', this.currentPage)

      window.history.pushState({}, '', url)
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollToPlugin)

    const url = new URL(window.location.href)
    if (url.searchParams.has('page')) {
      this.currentPage = parseInt(url.searchParams.get('page'))
    }
    this.pushState()
    this.getNews(this.currentPage)
    this.firstItemPerPage = (this.currentPage * this.itemsPerPage) - this.itemsPerPage + 1
    this.lastItemPerPage = this.currentPage * this.itemsPerPage
  }
}
</script>
